import React from "react";

function MinFullScreen(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 32 48"
      style={{fontSize: "1.5em"}}
      className={props.className}>
      <g id="Group_11787" data-name="Group 11787" transform="translate(-589 -895)">
        <g id="Group_11139" data-name="Group 11139" transform="translate(596 908)">
          <path id="Rectangle_382" data-name="Rectangle 382" d="M1,1V19H19V1H1M0,0H20V20H0Z" transform="translate(0 0)" fill="currentColor" />
        </g>
        <path id="Path_11809" data-name="Path 11809" d="M-6663-2035h-2v-5h-5v-2h7Z" transform="translate(2641 -5752) rotate(-90)" fill="currentColor" />
        <path id="Path_11810" data-name="Path 11810" d="M-6663-2035h-2v-5h-5v-2h7Z" transform="translate(-1429 7588) rotate(90)" fill="currentColor" />
      </g>
    </svg>
  );
}

export default MinFullScreen;